import * as React from 'react';

import FilePdf32 from './FilePdf32';

export const filePdf32 = () => <FilePdf32 />;

export default {
    title: 'Icon/Content/FilePdf32',
    component: FilePdf32,
    parameters: {
        notes: "`import FilePdf32 from 'box-ui-elements/es/icon/content/FilePdf32';`",
    },
};
